import { useEffect, useRef, useState } from "react";
import { FileText, CalendarCheck, Truck } from "lucide-react";

const steps = [
  { icon: FileText, num: "1", title: "Get a Quote", desc: "Fill out our simple form or give us a call. We'll get back to you fast." },
  { icon: CalendarCheck, num: "2", title: "Book Your Move", desc: "Pick a date and time that works for you. Easy as that." },
  { icon: Truck, num: "3", title: "We Move Everything", desc: "Our team shows up, loads up, and delivers, safely and on time." },
];

const HowItWorks = () => {
  const gridRef = useRef<HTMLDivElement>(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const el = gridRef.current;
    if (!el || revealed) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setRevealed(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [revealed]);

  return (
  <section id="how-it-works" className="scroll-mt-28 bg-white py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-dark text-center mb-4">
        How It Works
      </h2>
      <p className="text-center text-muted-foreground mb-14 max-w-lg mx-auto">
        Three simple steps to a stress free move.
      </p>
      <div ref={gridRef} className="relative grid md:grid-cols-3 gap-10 max-w-4xl mx-auto">
        {/* Subtle connecting line (desktop only), behind the icons, aligned to
            the vertical centre of the 80px icon circles. z-0 keeps it above the
            white section bg but below the z-10 step cards/icons. */}
        <span
          aria-hidden="true"
          className="hidden md:block absolute left-[16.6667%] right-[16.6667%] top-[39px] z-0 pointer-events-none"
          style={{ height: "2px", background: "rgba(0,0,0,0.18)" }}
        />
        {steps.map((s, i) => (
          <div
            key={s.num}
            className="hiw-step relative z-10 h-full flex flex-col items-center text-center px-2"
            data-revealed={revealed ? "true" : "false"}
            style={{ transitionDelay: `${i * 120}ms` }}
          >
            <div className="hiw-icon w-20 h-20 bg-yellow rounded-full flex items-center justify-center mb-5">
              <s.icon className="w-9 h-9 text-dark" />
            </div>
            <h3 className="hiw-title text-xl font-bold text-dark mb-2">{s.title}</h3>
            <p className="text-muted-foreground leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <a
          href="/#quote"
          className="inline-block bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity"
        >
          Get Started. It's Free
        </a>
      </div>
    </div>
  </section>
  );
};

export default HowItWorks;
